export default theme => ({
    footer: {
        display: 'flex',
        justifyContent: 'center',
        padding: '32px 0 75px 0',
        width: '100%'
    },
    footerRoot: {
        padding: theme.spacing(0, 4, 4, 4)
    },
    link: {
        color: 'rgba(0,0,0,0.87)',
        fontSize: '14px',
        letterSpacing: '0',
        lineHeight: '20px'
    },
    linkContainer: {
        '& > a': {
            '@media screen and (max-width: 320px)': {
                display: 'block'
            },
            paddingRight: '20px'
        },
        letterSpacing: '0',
        lineHeight: '16px',
        marginBottom: '8px'
    },
    loader: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
        'z-index': '10'
    },
    logo: {

    },
    logoContainer: {
        display: 'flex'
    },
    verbiageContainer: {
        color: 'rgba(0,0,0,0.54)',
        display: 'flex',
        fontSize: '12px',
        letterSpacing: '0',
        lineHeight: '16px',
        margin: '0 auto',
        marginBottom: '32px'
    }
})
